/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://news.files.bbci.co.uk/include/datapres/static-components/last-updated/1.0.5/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// You probably don't need to edit this file.

// This is required to include styles in the page
__webpack_require__(1);
__webpack_require__(2);

// Include the JS
__webpack_require__(3);

/***/ }),
/* 1 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * @param {string} selector - CSS selector to target elements
 */
function getLatestTimeStamp() {
    var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'div[data-md-render-date]';

    var timeStamps = [];
    var timeStampElementArray = [].slice.call(document.querySelectorAll(selector));

    if (!timeStampElementArray.length) {
        return;
    }

    timeStampElementArray.forEach(function (currentValue) {
        timeStamps.push(currentValue.getAttribute('data-md-render-date'));
    });

    if (timeStamps.length > 0) {
        return timeStamps.reduce(function (a, b) {
            return Math.max(a, b);
        });
    } else {
        return undefined;
    }
}

/**
 * @param {string} timestamp - single timestamp
 * @param {string} target - output destination
 */
function printFormattedTimeStamp(timestamp) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'nw-c-md-last-updated';

    if (timestamp === undefined) {
        return;
    }

    var date = new Date(timestamp);
    var hours = date.getHours();
    var minutes = (date.getMinutes() < 10 ? '0' : '') + date.getMinutes();
    var day = date.getDate();
    var months_arr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var month = months_arr[date.getMonth()];
    var year = date.getFullYear();

    var docFrag = document.createDocumentFragment();
    var element = document.createElement('p');
    element.className = 'nw-c-md-last-updated__text gs-u-mt-alt+ gs-u-mt0@m gs-u-mb-';
    element.innerHTML = 'As of <time>' + hours + ':' + minutes + '</time> ' + day + ' ' + month + ' ' + year;
    docFrag.appendChild(element);

    var targetElement = document.getElementsByClassName(target)[0];
    var targetFirstChild = document.getElementsByClassName(target)[0].firstElementChild;
    targetElement.insertBefore(docFrag, targetFirstChild);
}

// write latest update string to page
printFormattedTimeStamp(getLatestTimeStamp());

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// js/main.js